//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  VIEW_PROFILE: 'View profile',
  VIEW_AS_LEARNER: 'View as learner',
  SWITCH_LEARNING_SITE: 'Switch learning site',
  SIGN_OUT: 'Sign out',
  COPY_URL: 'Copy learning site URL',
  COPIED: 'URL Copied',
  PROFILE: 'Profile',
  ANNOUNCEMENT: 'Send an announcement',
});
